class More {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		// const box = $(this).closest('.js-more-content');
    $('.js-more-btn').click(function(){
      $(this).addClass('is-active');
			$(this).parent('.js-more-area').addClass('is-active');
      $(this).closest('.js-more-content').css('height', 'auto');
      // $(this).toggleClass('is-active');
      // if($(this).hasClass("is-active")) {
      // } else {
      //   $(this).find('.js-more-text').text('続きを見る');
      //   $(this).parent('.js-more-content').css('height', '50rem');
      // }
    });  
  }
}
